export default __webpack_public_path__ + "static/media/spursmax.d5eb1644.png";